/* global relatedPosts */
/**
 * createRelatedPost
 *
 * Fills the template of a related post item with the post data.
 *
 * @param {Object}  post           The information for the post.
 * @param {string}  post.url       The url to the single post page.
 * @param {string=} post.thumbnail The markup for the post thumbnail.
 * @param {string}  post.title     The post title.
 *
 * @return {string} The post template filled with the post data.
 */
const createRelatedPost = post => `
	<a href="${ post.url }">
		<div class="col-md-4 post-height">
			${ post.thumbnail ? post.thumbnail : '' }
			<h3>${ post.title }</h3>
		</div>
	</a>
`;

/**
 * fillContentContainerWithRelatedPosts
 *
 * Calculates how many rows of related articles fit down to the footer and
 * fills it up.
 *
 * @return {void}
 */
function fillContentContainerWithRelatedPosts() {
	// This height is the `min-height` set on the individual related posts.
	const articleHeight = 300;
	// This values comes from the `grid-template-columns` value on the .related-articles div.
	const articlesPerRow = 3;

	const containerElement = document.querySelector( '.container-posts' );
	const mainContentContainer = document.querySelector( '.main-content' );
	const relatedArticlesContainer = document.querySelector( '.related-articles' );

	if ( ! containerElement || ! mainContentContainer || ! relatedArticlesContainer ) {
		return;
	}

	const emptyContentSpace = containerElement.offsetHeight - mainContentContainer.offsetHeight;
	const rowsToFit = Math.round( emptyContentSpace / articleHeight );
	const postsToFit = rowsToFit * articlesPerRow;

	let posts = '';

	for ( let i = 0; i < postsToFit; i++ ) {
		if ( ! relatedPosts[ i ] ) {
			break;
		}

		posts += createRelatedPost( relatedPosts[ i ] );
	}

	relatedArticlesContainer.innerHTML += posts;
}

const windowWidth = window.innerWidth;
const isSinglePost = !! document.querySelector( 'body.single-post' );

if ( isSinglePost && windowWidth > 991 ) {
	setTimeout( fillContentContainerWithRelatedPosts(), 0 );
}
